__turbopack_context__.v({
  "body": "v3-module__rb_4Aq__body",
  "campaignDisplay": "v3-module__rb_4Aq__campaignDisplay",
  "eyebrow": "v3-module__rb_4Aq__eyebrow",
  "heroTitle": "v3-module__rb_4Aq__heroTitle",
  "pill": "v3-module__rb_4Aq__pill",
  "pillPrimary": "v3-module__rb_4Aq__pillPrimary",
  "pillSecondary": "v3-module__rb_4Aq__pillSecondary",
  "pillSecondaryOnDark": "v3-module__rb_4Aq__pillSecondaryOnDark",
  "sectionTitle": "v3-module__rb_4Aq__sectionTitle",
  "srOnly": "v3-module__rb_4Aq__srOnly",
  "subTitle": "v3-module__rb_4Aq__subTitle",
  "titleFaint": "v3-module__rb_4Aq__titleFaint",
  "titleFaintOnDark": "v3-module__rb_4Aq__titleFaintOnDark",
});
